var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreenPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#3DB460"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.171,
  d: "M21.746 14.19H15.54V8.254a.54.54 0 1 0-1.08 0v5.936H8.254a.54.54 0 1 0 0 1.08h6.206v6.476a.54.54 0 1 0 1.08 0V15.27h6.206a.54.54 0 1 0 0-1.08Z"
})));
export default SvgGreenPlus;